import { useNavigate } from "react-router-dom"
import Modal from "components/Modal/Modal"
import Button from "components/Button"

interface ModalChooseOptionProps {
  qr_id: string
  id: string
  onClose: () => void
}

const ModalChooseOption: React.FC<ModalChooseOptionProps> = ({ id, qr_id, onClose }) => {
  const navigate = useNavigate()
  return (
    <Modal
      onClose={onClose}
      title={'Co chcesz zrobić?'}>
      <div className="modal__fromQr">
        <h2>Wybierz co chcesz zrobić</h2>
        <Button type={'secondary'} icon='qr-code' text="Dodaj kolejną osobę do tabliczki" action={() => navigate(`/addprofile/${qr_id}/add`)} />
        <Button type={'secondary'} icon='settings' text="Zarządzaj" action={() => navigate(`/manage/${id}`)} />
        <Button type={'primary'} icon='user-box' text="Podgląd" action={() => navigate(`/profile/${id}`)} />
      </div>
    </Modal>)
}

export default ModalChooseOption